var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fileReady)?_c('iframe',{ref:"myIframe",style:(`
  width:100%; 
  height:calc(100vh - ${_vm.minusHeight}px);`),attrs:{"src":`${_vm.file.link}#toolbar=0&navpanes=0`,"frameborder":"0"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }